const getCardColor = (number) => {
    switch (number) {
        case 1:
          return {
            main: 'rgb(241,80,125)',
            light: 'rgb(241,80,125,0.2)',
          }
        case 2:
          return {
            main: 'rgb(111,109,176)',
            light: 'rgb(111,109,176,0.2)',
          }
        case 3:
          return {
            main: 'rgb(50,176,223)',
            light: 'rgb(50,176,223,0.2)',
          }
        case 4:
          return {
            main: 'rgb(57,193,195)',
            light: 'rgb(57,193,195, 0.2)',
          }
        case 5:
          return {
            main: 'rgb(13,31,45)',
            light: 'rgb(13,31,45, 0.2)',
          }
        case 6:
          return {
            main: 'rgb(125,29,63)',
            light: 'rgb(125,29,63, 0.2)',
          }
        case 7:
          return {
            main: 'rgb(3,76,60)',
            light: 'rgb(3,76,60, 0.2)',
          }
        case 8:
          return {
            main: 'rgb(37,60,120)',
            light: 'rgb(37,60,120, 0.2)',
          }
        case 9:
          return {
            main: 'rgb(13,93,86)',
            light: 'rgb(13,93,86, 0.2)',
          }
        case 10:
          return {
            main: 'rgb(255,22,84)',
            light: 'rgb(255,22,84, 0.2)',
          }
        default:
          return {
            main: 'rgb(86,88,87)',
            light: 'rgb(86,88,87, 0.2)',
          }
      }
}

export default getCardColor